import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { RadioButton } from 'ui';

import s from './RadioGroupAnswer.module.scss';

const cx = cn.bind(s);

const RadioGroupAnswer = ({
  options = [],
  className,
  value,
  onChange,
  ...attrs
}) => {
  const handleChange = (ev) => {
    onChange(ev.target.value)
  }
  return (
    <div
      className={cx(className, 'wrapper')}
      {...attrs}
    >
      {options.map(option => (
        <RadioButton
          key={option.value}
          className={cx('item')}
          label={option.label}
          value={option.value}
          labelClassName="tp-header-4"
          checked={value === option.value}
          onChange={handleChange}
        />
      ))}
    </div>
  );
};
RadioGroupAnswer.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RadioGroupAnswer;
